import axios from '../api/axios';

export const PRIVILEGED_SPECIAL_ROLES = [1984, 5150, 2020];

export const canEditRestaurantSpecials = (roles) =>
  roles?.some((role) => PRIVILEGED_SPECIAL_ROLES.includes(role));

export const getRestaurantKey = (item) => {
  if (item?.restaurantKey) return item.restaurantKey;
  if (item?.placeId) return `google:${item.placeId}`;
  const slug = String(item?.name || 'restaurant')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return `curated:${slug}`;
};

export const fetchRestaurantSpecials = async (restaurantKeys, accessToken) => {
  const keys = [...new Set(restaurantKeys.filter(Boolean))];
  if (!keys.length) {
    return { published: {}, proposals: {}, confirmThreshold: 3 };
  }

  const config = accessToken
    ? { headers: { Authorization: `Bearer ${accessToken}` } }
    : undefined;

  const response = await axios.get('/restaurant-specials', {
    ...config,
    params: { keys: keys.join(',') },
  });

  return response.data || { published: {}, proposals: {}, confirmThreshold: 3 };
};

export const mergeRestaurantSpecials = (locations, published = {}) =>
  locations.map((item) => {
    const restaurantKey = getRestaurantKey(item);
    const community = published[restaurantKey];
    if (!community) {
      return { ...item, restaurantKey };
    }

    return {
      ...item,
      restaurantKey,
      special: community.special || item.special,
      specialinfo: community.specialinfo || item.specialinfo,
      price: community.price || item.price,
      hasCommunitySpecial: true,
      specialUpdatedBy: community.updatedBy,
      specialUpdatedAt: community.updatedAt,
      specialSource: community.source,
    };
  });

export const upsertRestaurantSpecial = (payload, accessToken) =>
  axios.put('/restaurant-specials', payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

export const submitRestaurantSpecialProposal = (payload, accessToken) =>
  axios.post('/restaurant-specials/proposals', payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

export const confirmRestaurantSpecialProposal = (proposalId, accessToken) =>
  axios.post(`/restaurant-specials/proposals/${proposalId}/confirm`, null, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });